<p-confirmdialog />
<p-toast />
<div *ngIf="isLoading" class="flex items-center justify-center h-screen">
  <p-progressSpinner></p-progressSpinner>
</div>

<div class="container px-4 py-10 mx-auto">
  <div *ngIf="!isLoading && object" class="bg-white rounded-md">
    <p-card class="p-card" header="Invoices">
      <div class="w-full p-7">
        <ng-template pTemplate="header">
          <h2 class="text-2xl font-bold">Invoice Details</h2>
        </ng-template>
        <div class="text-right">
          <p-button
          (click)="menu.toggle($event)"
          icon="pi pi-ellipsis-v" />            
        </div>
        <p-menu appendTo="body" #menu [model]="items" [popup]="true" />
        <div class="col-span-12 mb-4 md:col-span-6">
          <label for="first_name" class="block mb-1 font-medium">
            Invoice #
          </label>
          <input
            p-inputText
            id="first_name"
            [ngModel]="object.invoice_number"
            type="text" />
        </div>
        <div class="col-span-12 mb-4 md:col-span-6">
          <label for="first_name" class="block mb-1 font-medium">
            Status
          </label>
          <input
            p-inputText
            id="first_name"
            [ngModel]="object.status"
            type="text" />
        </div>
      <div class="col-span-12 mb-4 md:col-span-6">
            <label for="first_name" class="block mb-1 font-medium">
              Customer Name
            </label>
            <input
              p-inputText
              id="first_name"
              [ngModel]="object.customer?.name"
              type="text" />
          </div>
          <div class="col-span-12 mb-4 md:col-span-6">
            <label for="first_name" class="block mb-1 font-medium">Date</label>
            {{ object.createdAt | date }}
          </div>
          <div class="col-span-12 mb-4 md:col-span-6">
            <label for="first_name" class="block mb-1 font-medium">
              Amount
            </label>
            {{ object.including_tax | currency : "USD" }}
          </div>
          <div class="col-span-12 mb-4 md:col-span-6">
            <label for="first_name" class="block mb-1 font-medium">
              Deleted
            </label>
            {{ object.is_deleted | boolToText }}
          </div>
          <div class="col-span-12 mb-4 md:col-span-6">
            <label
              for="references"
              class="block mb-1 font-medium"
              >Payment Attempts</label
            >
            <div>
              <pre [innerHTML]="object.payment_attempts | jsonToText"></pre>
          </div>
          <div>
            <pre [innerHTML]="object.lines.data| jsonToText"></pre>
        </div>
      </div>
        <ng-template pTemplate="footer">
          <button
            pButton
            label="Back to List"
            icon="pi pi-arrow-left"
            class="p-button-secondary"
            routerLink="/invoices/list"></button>
        </ng-template>
      </div>
    </p-card>
  </div>
</div>
